import { render, staticRenderFns } from "./detail-dialog.vue?vue&type=template&id=31bbf7f6&scoped=true"
import script from "./detail-dialog.vue?vue&type=script&lang=ts"
export * from "./detail-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bbf7f6",
  null
  
)

export default component.exports